module.exports = __webpack_public_path__ + "static/media/24-lave.13cc1182.mp3";